import { render, staticRenderFns } from "./tags.vue?vue&type=template&id=7c2c826d&scoped=true&"
import script from "./tags.vue?vue&type=script&lang=js&"
export * from "./tags.vue?vue&type=script&lang=js&"
import style0 from "./tags.vue?vue&type=style&index=0&id=7c2c826d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2c826d",
  null
  
)

export default component.exports